import React from "react";
import { Link } from "react-router-dom";

const CallToAction = () => {
  return (
    <div className="h-2/5 sm:h-[400px] bg-black flex-col w-screen justify-center">
      <h1 className="w-full h-1/3 text-primary text-4xl pt-8 sm:pt-16 pb-14 sm:text-7xl sm:p-10 font-bold text-center">
        Find Out What You Can Do Today!
      </h1>
      <div className="h-2/3 w-full  flex items-center justify-center">
        <Link to="/get-a-quote">
          <p className="h-[50px] text-black w-[200px] sm:h-[100px] sm:w-[400px] sm:text-4xl  sm:font-bold flex items-center justify-center bg-primary">
            Get A Quote!
          </p>
        </Link>
      </div>
    </div>
  );
};

export default CallToAction;
